import type { Step } from "react-joyride";

export const communicationHubTourSteps: Step[] = [
  {
    target: "body",
    content: "ຍິນດີຕ້ອນຮັບສູ່ສູນກາງການສື່ສານ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="communication-overview-cards"]',
    content: "ບັດເຂົ້າເຖິງດ່ວນສຳລັບທຸກພື້ນທີ່ການສື່ສານ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="communication-activity-cards"]',
    content: "ການອັບເດດແລະການແຈ້ງເຕືອນຫຼ້າສຸດສະແດງຢູ່ບ່ອນນີ້.",
    placement: "top",
  },
];

export const meetingsTourSteps: Step[] = [
  { target: "body", content: "ລາຍການກອງປະຊຸມຂອງທ່ານ.", placement: "center", disableBeacon: true },
  { target: '[data-tourid="communication-meetings-list"]', content: "ກອງປະຊຸມທີ່ທ່ານເປັນຜູ້ເຂົ້າຮ່ວມ.", placement: "top" },
];

export const minutesTourSteps: Step[] = [
  { target: "body", content: "ຄັງບັນທຶກກອງປະຊຸມ.", placement: "center", disableBeacon: true },
  { target: '[data-tourid="communication-minutes-list"]', content: "ບັນທຶກທີ່ທ່ານສາມາດເບິ່ງໄດ້ (ອ່ານຢ່າງດຽວ).", placement: "top" },
];

export const calendarTourSteps: Step[] = [
  { target: "body", content: "ປະຕິທິນວຽກແລະວຽກທີ່ມອບຫມາຍ.", placement: "center", disableBeacon: true },
  { target: '[data-tourid="communication-calendar-list"]', content: "ເສັ້ນເວລາກິດຈະກຳແລະວຽກສ່ວນຕົວ.", placement: "top" },
];

export const notificationsTourSteps: Step[] = [
  { target: "body", content: "ສູນກາງການແຈ້ງເຕືອນສ່ວນຕົວຂອງທ່ານ.", placement: "center", disableBeacon: true },
  { target: '[data-tourid="communication-notifications-list"]', content: "ເປີດອ່ານແລະກົດຫມາຍເຫດວ່າອ່ານແລ້ວ.", placement: "top" },
];
